import API from "@/models/API";

export default class Billings {
    static updateStatus = payload =>
        API.patch(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/subscriptions/billings/${payload.id}`, payload.body
        );

    static notifyBilling = payload =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/subscriptions/payment-code/billing/${payload.billing_id}/notify`
        );

    static getBillings = (id, page) =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/subscriptions/${id}?page=${page}`
        );
}